import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const serviceApiKeySlice = createSlice({
  name: 'serviceApiKey',
  initialState,
  reducers: {},
});

export default serviceApiKeySlice.reducer;
